import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'
import { useRequestLdFlags } from '../launch-darkly'

// Both gates required: the org flag AND the LD release flag (matches the settings card behaviour).
export const useShowOperationalStatus = () => {
  const { AI_OPERATIONAL_STATUS } = useFeatureFlags()
  const { RELEASE_AI_OPERATIONAL_STATUS } = useRequestLdFlags()
  return AI_OPERATIONAL_STATUS && RELEASE_AI_OPERATIONAL_STATUS
}
